import FileDownload from "js-file-download";
import { translate } from "../../infrastructure/translate/localization";

export function downloadTemplateFilterFile() {
  const forceExcelUTF8 = "\ufeff";
  const data = "jra@email.com;\nmg@email.com;";
  const title = `${translate(
    "employees-section.filters-section.example-template"
  )}.csv`;

  FileDownload(forceExcelUTF8 + data, title);
}
